import Logger from "../../clients/sentry";
import { handleError } from "../../errors";
import { fetchEstimateMilestonesByProjectIdUncached, fetchEstimatesByProjectId } from "../../api";
import { Estimate } from "../../interfaces/Estimate";
import { LoggingInfo } from "./types";

export function useEstimateActions() {
  const withEstimateLogging = async (callback: () => Promise<any>, loggingInfo?: LoggingInfo) => {
    try {
      await callback();
    } catch (error) {
      const err = handleError(error, {
        context: loggingInfo?.context || "withEstimateLogging",
      });
      const message = loggingInfo?.message || "Error generating estimate";
      Logger.error(message, err);
      throw err;
    }
  };

  const getEstimatesByProjectId = async (projectId: string): Promise<Estimate[]> => {
    const result = await fetchEstimatesByProjectId(projectId);
    if (!result.success) {
      const err = handleError(result.error, { context: "getEstimatesByProjectId" });
      Logger.error("Failed to fetch estimates data", err);
      throw err;
    }
    return result.data || [];
  };

  const getMilestonesByProjectId = async (projectId: string) => {
    const result = await fetchEstimateMilestonesByProjectIdUncached(projectId);
    if (!result.success) {
      const err = handleError(result.error, { context: "getMilestonesByProjectId" });
      Logger.error("Failed to fetch milestone data", err);
      throw err;
    }
    return result.data || [];
  };

  return {
    withEstimateLogging,
    getEstimatesByProjectId,
    getMilestonesByProjectId,
  };
}
